import React from 'react';
import { Redirect, Route, Switch } from 'react-router-dom';

import QBotPrimaryDialog from '../json-pages/QBotPrimaryDialog';

const UI = ({ match }) => (
  <div className="dashboard-wrapper">
    <Switch>
      <Route path={`${match.url}/primary`} component={QBotPrimaryDialog} />
      <Redirect to="/error" />
    </Switch>
  </div>
);
export default UI;
